"use strict"

import React, {useEffect} from "react"
import {observer} from "mobx-react"
import moment from "moment"
import {injectIntl} from "react-intl"
import {Container, Box, Grid, Typography} from "@material-ui/core"
import XsButton from "../../global/ui/xsButton/xsButton"
import XsTable from "../../global/ui/xsTable/xsTable"
import RequestStore from "./requestStore"
import RouterStore from "../../global/store/RouterStore"
import RequestFormStore from "../RequestForm/RequestFormStore"
import {getUserCompanyInfo} from "../../global/helpers/actions"
import ConsentSentDialog from "./ConsentSentDialog"
import ConsentSentDialogStore from "./ConsentSentDialogStore"
import WarningDialogStore from "../RequestForm/WarningDialogStore"
import WarningDialog from "../RequestForm/WarningDialog"

const columns = [
	{
		Header: "Poradie",
		width: 50,
		accessor: "request_sequence"
	},
	{
		Header: "Dátum odoslania žiadosti",
		width: 100,
		accessor: "sent_date_time",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Číslo žiadosti",
		width: 120,
		accessor: "request_number"
	},
	{
		Header: "Stav žiadosti",
		width: 120,
		accessor: "status_name_ext"
	},
	{
		Header: "Štart kola výzvy",
		width: 120,
		accessor: "start",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Akcie",
		type: "action",
		width: 10,
		accessor: "request_id",
		Cell: (props) => {
			if (props.row.original.status_name_ext === "Registrovaná") {
				return (
					<i
						className="fas fa-paper-plane fa-lg"
						onClick={() => {
							ConsentSentDialogStore.open(props.value)
						}}
					></i>
				)
			}

			return ""
		}
	}
]

function Requests() {
	useEffect(() => {
		RequestStore.getRequests()
	}, [])

	const company = getUserCompanyInfo() || {}

	return (
		<Container maxWidth="lg">
			<Grid container justify="space-between" alignItems="center" className="mt-8">
				<Grid item>
					<Typography variant="h4">Zoznam žiadostí (IČO: {company.identifier || ""})</Typography>
				</Grid>
				<Grid item>
					<XsButton
						text="NOVÁ ŽIADOSŤ"
						icon={<i className="fas fa-plus"></i>}
						onClick={() => {
							RequestFormStore.showEditButton = false
							RequestFormStore.requestInProgress = true
							RouterStore.push("/request")
						}}
					/>
				</Grid>
			</Grid>
			<Box pt={2}>
				<Grid container>
					<Grid item xs={12}>
						<Box pt={1}>
							<XsTable
								columns={columns}
								data={RequestStore.data}
								onRowClick={(row) => RouterStore.push(`/request?id=${row.request_id}`)}
							/>
						</Box>
					</Grid>
				</Grid>
			</Box>
			<ConsentSentDialog />
			{WarningDialogStore.isOpen && <WarningDialog />}
		</Container>
	)
}

export default injectIntl(observer(Requests))

